module.exports = {"<!-- path":"/404.html -->","body":"<h1>NOT FOUND</h1>\n<p>You just hit a route that doesn’t exist… the sadness.</p>\n<p>Try logging in here <a href=\"http://app.seter.io/login\">app.setter.io/login</a></p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./OLD40.md
 ** module id = 511
 ** module chunks = 0
 **/